import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=2aa2529a&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"
import style0 from "./orderPay.vue?vue&type=style&index=0&id=2aa2529a&lang=scss&scoped=true&"
import style1 from "./orderPay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2529a",
  null
  
)

export default component.exports